import axios from 'axios';
import { Clip, EtvConfig, PlayerConfig } from '@/interfaces/player-config.interface';
import Vue from 'vue';

export enum eventType {
  LIVE = 'LIVE',
  CLIP = 'CLIP',
}

class StatisticService {
  private reporting: any;

  private analytics: any;
  private location: any = undefined;

  private gtmInitialized: boolean = false;
  private reInitialized: boolean = false;
  private etvConfig: EtvConfig | undefined;
  private playerConfig: PlayerConfig | undefined;

  /**
   * Add Google Tag Manager support to player
   * https://earthtv.atlassian.net/browse/WV-114
   */
  public async initGTMScript(gtmId: string, etvConfig: EtvConfig, playerConfig: PlayerConfig) {
    this.etvConfig = etvConfig;
    this.playerConfig = playerConfig;
   
    if (!gtmId) {
      return;
    }

    try {
      this.addGTMScript(gtmId);
      this.gtmInitialized = true;
    } catch (error) {
      this.gtmInitialized = false;
    }
  }

  public async addGTMScript(gtmId: string) {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.innerHTML =
      '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push' +
      "({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)" +
      "[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
      "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})" +
      "(window,document,'script','dataLayer','" +
      gtmId +
      "');";
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(s);
  }

  public initReporting() {
    this.reInitialized = true;
  }

  public updateConfig(config: EtvConfig) {
    if (config.source) {
      this.location = config.source.alias ? config.source.alias : config.source.id;
      this.etvConfig = config;
    }
  }

  /**
   * eventActions:
   *
   * Video Initial Play:  First time the user clicks on the play button
   * Video Play:          User clicks on the play button
   * Video Start:         The video starts to play
   * Video Pause:         User clicks the pause button
   * Video Completed:     Stream end event
   *
   * PrerollAdX Start:    Preroll start event
   * PrerollAdX Ad Start: Preroll starts to play
   * Ad endet:            Ad end event
   * PrerollAdX Completed: end of preroll
   *
   *
   * @param {*} eventAction
   * @param {*} category
   */
  public ga(eventAction: string) {


    if (!this.gtmInitialized || !this.playerConfig || !this.etvConfig) {
      return;
    }

    const type = this.playerConfig.live ? eventType.LIVE : eventType.CLIP;
    let eventCategory;


    (window as any).dataLayer = (window as any).dataLayer || [];

    // CLIP MODE
    if (type === eventType.CLIP) {
      eventCategory = 'video';
      if (this.playerConfig?.playlist &&  Vue.prototype.$player && Vue.prototype.$player.playlist) {
        const currentClip: Clip = this.playerConfig?.playlist[ Vue.prototype.$player.playlist.currentIndex()];
        this.location = currentClip.source.alias ? currentClip.source.alias : currentClip.source.id;
      }
    }

    // LIVE MODE
    if (type === eventType.LIVE) {
      eventCategory = 'livecam';
      if (this.etvConfig.source) {
        this.location = this.etvConfig.source.alias ? this.etvConfig.source.alias : this.etvConfig.source.id;
      }
    }

    const layer: any = {
      event: eventAction,
      type: eventCategory,
      location: this.location,
      info: {
        parentUrl: this.playerConfig.parentFullUrl,
        accountId: this.playerConfig.accountId,
        powerlink: this.etvConfig.template.advertisement.powerlink.enabled,
        preroll: this.etvConfig.template.advertisement.preroll.enabled,
        midroll: this.etvConfig.template.advertisement.midroll.enabled,
      },
    };

    (window as any).dataLayer.push(layer);
  }

  public report(eventAction: string, streamUrl: any) {
    if (!this.reInitialized) {
      return;
    }

    // var skip = true;

    // if(app.reporting || config.reporting) {
    //     skip = false;
    // }

    const TOKEN = streamUrl.split('token=').pop();
    const urlParts = streamUrl.split('/');

    let APPLICATION = urlParts[3];
    let STERAM = urlParts[4];
    //  check edge or cdnedge
    if (streamUrl.indexOf('out-stream.earthtv.com') < 0) {
      APPLICATION = urlParts[4];
      STERAM = urlParts[5];
    }

    const ev = {
      token: TOKEN,
      application: APPLICATION,
      referrer: document.referrer,
      stream: STERAM,
      event: eventAction,
    };

    const evString = JSON.stringify(ev);

    axios
      .post(process.env.VUE_APP_REPORTING_PATH as string, evString)
      .then((response) => {
        // console.log('response', response);
      })
      .catch((error) => {
        // console.log('response', error);
      });
  }
}

export const statisticService = new StatisticService();
